var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowsSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.626 1.793a1 1 0 0 1 1.415 0l3.333 3.333a1 1 0 0 1 0 1.414L14.04 9.874a1 1 0 1 1-1.415-1.414l1.627-1.627H3.332a1 1 0 1 1 0-2h10.92l-1.627-1.626a1 1 0 0 1 0-1.414m-5.252 8.333a1 1 0 0 1 0 1.414l-1.626 1.627h10.919a1 1 0 1 1 0 2H5.747l1.627 1.626a1 1 0 1 1-1.414 1.414l-3.334-3.333a1 1 0 0 1 0-1.414l3.334-3.334a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})));
SvgArrowsSwitch.displayName = "SvgArrowsSwitch";
export { SvgArrowsSwitch as ReactComponent };
export default SvgArrowsSwitch;